import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { FlexRow } from 'src/components/flex-containers'

const Spacer = styled.span`
  flex: 1;
  height: 1px;
  background-color: ${Colors.neutral100};
`

export const DividerText: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <FlexRow
      style={{
        marginBlock: `${Shapes.spacing[2]}px`,
      }}
      gap={Shapes.spacing[1]}
      align="center">
      <Spacer />
      {typeof children === 'string' ? (
        <Typography variant="text2m" color={Colors.textMedium}>
          {children}
        </Typography>
      ) : (
        children
      )}
      <Spacer />
    </FlexRow>
  )
}
